import React from 'react'
import { Button, Card, Col, Flex, Row, Form, Typography, Image, Divider} from 'antd'
import {MyInput } from '../../components'
import { motion } from 'framer-motion'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { actionsApi } from '../../shared'

const { Text, Title } = Typography
const Forgotpassword = () => {
    
    const [form] = Form.useForm();
    const dispatcher = useDispatch();
    const navigate = useNavigate();
    const { loading, otpToken , requestState } = useSelector(state => state?.loginAndSignUp);
    
    const forgotpass = () => {
        if (requestState === "request") {
            dispatcher(actionsApi?.forgotPassword(form.getFieldsValue(['email'])));
        } 
        if (requestState === "otp") {
            dispatcher(actionsApi?.otpVerify(form.getFieldsValue(['otp'])));
        }
        if (requestState === "reset") {
            const data = form.getFieldsValue(['password', 'confirmationPassword']);
            dispatcher(actionsApi?.resetPassword({data:{token: otpToken, ...data}, navigate}));
        }
    };
  return (
    <div className='padding padding-main'>
        <div className='container'>    
            <Row justify={'center'}>
                <Col lg={{span: 12}} md={{span: 12}} sm={{span: 24}} xs={{span: 24}}>
                    <Card className='bg-transparent shadow-c my-5'>
                        <Flex vertical align="center" justify="center" gap={15}>
                            <motion.div
                                initial={{ y: '-100%', opacity: 0 }}
                                whileInView={{
                                    opacity: 1,
                                    y: 0,
                                }}
                                transition={{ delay: .1, duration: 1, }}
                                viewport={{once: true}}>
                                <Image
                                    src={"/assets/images/logo.png"}
                                    alt='mozeef'
                                    preview= {false}
                                    width={'100px'}
                                />
                            </motion.div>
                            <Flex vertical gap={3} align='center'>
                                <motion.div
                                    initial={{ y: '-100%', opacity: 0 }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0,
                                    }}
                                    transition={{ delay: .2, duration: 1, }}
                                    viewport={{once: true}}>
                                    <Title 
                                        level={3} 
                                        className="brown-gadient m-0"
                                        >
                                        Welcome to Nextdoor Pros
                                    </Title>
                                </motion.div>
                                <motion.div
                                    initial={{ y: '-100%', opacity: 0 }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0,
                                    }}
                                    transition={{ delay: .2, duration: 1, }}
                                    viewport={{once: true}}>
                                    <Text level={5} className="text-gray">
                                        {requestState === 'request' && 'Forgot Password'}
                                        {requestState === 'otp' && 'Enter OTP'}
                                        {requestState === 'reset' && 'Reset Password'}
                                    </Text>
                                </motion.div>
                            </Flex>
                        </Flex>
                        <motion.div
                            initial={{ y: '100%', opacity: 0 }}
                            whileInView={{
                                opacity: 1,
                                y: 0,
                            }}
                            transition={{ delay: .3, duration: 1, }}
                            viewport={{once: true}}
                        >
                            <Form 
                                form={form}
                                layout='vertical'
                                requiredMark={false}
                                className='mt-3'
                                onFinish={forgotpass}
                            >
                                <Row gutter={[16, 16]}>
                                    {requestState === 'request' && (
                                    <Col span={24}>
                                        <MyInput
                                            label="Email"
                                            name="email"
                                            required
                                            message="Please enter email"
                                            placeholder=""
                                        />
                                    </Col>
                                    )}
                                    {requestState === 'otp' && (
                                    <Col span={24}>
                                        <MyInput
                                            oTp
                                            label="OTP"
                                            name="otp"
                                            type='number'
                                            required
                                            message="Please enter the OTP sent to your email"
                                            placeholder="Enter OTP"
                                            onKeyPress={(e) => {
                                                if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                                }
                                            }}
                                        />
                                    </Col>
                                    )}
                                    {requestState === 'reset' && (
                                    <>
                                        <Col span={24}>
                                            <MyInput
                                                label="New Password"
                                                type="password"
                                                name="password"
                                                required
                                                message={()=>{}}
                                                validator={({ getFieldValue }) => ({
                                                    validator: (_, value) => {
                                                        const reg = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*\d).{8,}$/;
                                                        if (!reg.test(value)) {
                                                            return Promise.reject(new Error('Password should contain at least 8 characters, one uppercase letter, one number, one special character'));
                                                        } else {
                                                            return Promise.resolve();
                                                        }
                                                    }
                                                })}
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <MyInput
                                                label="Confirm Password"
                                                type="password"
                                                name="confirmationPassword"
                                                dependencies={['password']}
                                                required
                                                message='Please enter confirm password'
                                                rules={[
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            if (!value || getFieldValue('password') === value) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error('The password that you entered do not match!'));
                                                        },
                                                    }),
                                                ]}
                                                validator={({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                        if (!value || getFieldValue('password') === value) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(new Error('The password that you entered do not match!'));
                                                    },
                                                })}
                                            />
                                        </Col>
                                    </>
                                    )}
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Button className="btn rounded mt-2 fw-500"
                                            htmlType="submit" 
                                            size="large"
                                            block 
                                            loading={loading}
                                        >
                                            {requestState === 'request' && 'Request for OTP'}
                                            {requestState === 'otp' && 'Verify OTP'}
                                            {requestState === 'reset' && 'Reset Password'}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </motion.div>
                        { requestState === 'request' && (
                        <>
                            <div >
                                <Divider style={{borderColor:'gray'}} className='text-gray mt-4'>
                                    OR
                                </Divider>
                            </div>
                            <Flex gap={10} justify='center' className='mt-3'>
                                <Text className='text-gray'>
                                    <Link to={'/login'} className='px-2 text-brand'>
                                        <strong>Sign In</strong>
                                    </Link>
                                </Text>
                            </Flex>
                        </>
                        )}
                    </Card>  
                </Col>
            </Row>
        </div>
    </div>
  )
}

export {Forgotpassword}